﻿
export function LoadingSpinner() {
  return (
    <div className="spinner-wrapper">
      <div className="spinner" />
    </div>
  )
}

